$(document).ready(function(){
    $('.product-included-parts').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        dots: false,
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev nav-arrow'>&larr;</button>",
        nextArrow: "<button type='button' class='slick-next nav-arrow'>&rarr;</button>",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
});

$(document).ready(function(){
  $('.reviews-slider').slick({
      slidesToShow: 3, // Default: Show 3 slides
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      dots: true,
      infinite: true,
      responsive: [
          {
              breakpoint: 1024, // Tablet devices
              settings: {
                  slidesToShow: 2 // Show 2 slides on tablets
              }
          },
          {
              breakpoint: 768, // Mobile devices
              settings: {
                  slidesToShow: 1 // Show 1 slide on mobile
              }
          }
      ]
  });
});

$(document).ready(function(){
  var $slider = $('.global-product-slider .product-slider');
  var slideCount = $slider.children().length;

  if(slideCount >= 3){
    if(slideCount === 3){
      $slider.children().clone().appendTo($slider);
    }

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,          
      autoplay: true,        
      autoplaySpeed: 3000,     
      arrows: true,
      prevArrow: $('.global-product-slider .custom-arrows .prev'),
      nextArrow: $('.global-product-slider .custom-arrows .next'),
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 768,  settings: { slidesToShow: 1 } }
      ]
    });
  } else {
    $('.global-product-slider .custom-arrows').hide();
  }
});

$(document).on('click', '.swatch', function(){
  var $this = $(this);
  var $card = $this.closest('.product-card');

  var newImage = $this.data('image');
  var variantId = $this.data('variant-id');
  $card.find('.main-image').attr('src', newImage);
  $card.find('.swatch').removeClass('active');
  $this.addClass('active');
  $card.find('.add-to-cart')
       .attr('href', '/cart/add?id=' + variantId);
});
$('.product-card').each(function(){
  $(this).find('.swatch').first().addClass('active');
});

document.addEventListener("DOMContentLoaded", function() {
  // ✅ Only run if elements actually exist on this page
  var firstTab = document.querySelector(".tablinks");
  var firstContent = document.querySelector(".tabcontent");

  if (firstTab) firstTab.classList.add("active");
  if (firstContent) firstContent.style.display = "block";
});

$(document).ready(function(){
  var $slider = $('.dynamic-product-slider .product-slider');
  var slideCount = $slider.children().length;

  if(slideCount >= 3){
    if(slideCount === 3){
      $slider.children().clone().appendTo($slider);
    }

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      prevArrow: $('.dynamic-product-slider .custom-arrows .prev'),
      nextArrow: $('.dynamic-product-slider .custom-arrows .next'),
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 768,  settings: { slidesToShow: 1 } }
      ]
    });
  } else {
    $('.dynamic-product-slider .custom-arrows').hide();
  }
});

function openTab(evt, tabName) {
  var i, tabcontent, tablinks;

  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // ✅ Guard here too, in case tabName doesn't exist
  var selectedTab = document.getElementById(tabName);
  if (selectedTab) selectedTab.style.display = "block";
  evt.currentTarget.className += " active";
}